/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchCatalog = {
    /**
     * Execute after init of component
     * Entry point for catalog search
     */
    initCatalog() {
        this.handlePageState()
        this.setCurrentPage()
        this.handleSelectedFacetsChange()

        // Watch for changes in selected facets
        window.addEventListener('facets-changed', () => {
            this.handleSelectedFacetsChange()
        })

        this.getProducts('initial', this.pagesCurrent)
    }
}

export default liveSearchCatalog
